export const MEAL_TYPES = [
  'breakfast',
  'lunch',
  'main_meal',
  'snack',
  'dinner',
  'pre_workout',
  'post_workout',
] as const;

export type MealType = (typeof MEAL_TYPES)[number];
